const React = require('react');
const classnames = require('classnames');
import config from '../../../config.js';
import './phone-verification-code.scss';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import { getUrlParam } from '../../../helper/common-helper.js';
import PhoneVerificationCode from './phone-verification-code';
import BaseComponent from '../../../helper/BaseComponent';
import fetchHelper from '../../../helper/fetch-helper';
import FloatScrollSelector from '../../common/floating-scroll-selector';
import PayMethodOption from '../../../component/order/select/pay-method-option';
const shopId = getUrlParam('shopId');

import { formatMessage } from '../../../intl/helper';
import muiText from '../../..//intl/messages/mui';
class InternationalPhoneVerificationCode extends BaseComponent {
  static propTypes = {}

  constructor(props) {
    super(props);

    this.state = {
      showPhonePanel: false,
      initCountryList: [],
      chosenCountryList: [],
    };

    this.bind(
      'handleChange',
      'handleClickChange',
      'closeModal',
      'toggleSelectorCheckedStatus',
      'setSelectedOption',
    );
  }

  componentDidMount() {
    fetchHelper.get(config.getCurrentCountryList, { shopId })
      .then((res = []) => {
        const data = res.map((item, index) => (
          { ...item, name: item.countryZh, value: item.countryEn, id: index, isChecked: index === 0, isAllowSendCode: true }
        ));

        this.setState({ initCountryList: data, chosenCountryList: data });
      });
  }

  handleChange = () => {
    const { showPhonePanel, chosenCountryList } = this.state;

    if (this.isSpecialOption()) {
      return;
    }

    this.setState({ showPhonePanel: !showPhonePanel, initCountryList: chosenCountryList });
  }

  isSpecialOption = () => {
    const { type } = this.props;

    if (type === 'bind-phone') {
      return true;
    }

    return false;
  }

  handleClickChange = (value) => {
    this.closeModal();
  }

  closeModal = (e) => {
    if (e) {
      e.preventDefault();
    }

    this.setState({ showPhonePanel: false });
  }

  toggleSelectorCheckedStatus = (value) => {
    const { initCountryList } = this.state;
    const chosenCountryList = initCountryList.map((item, index) => ({ ...item, isChecked: index === value }));

    this.setState({ initCountryList: chosenCountryList });
  }

  setSelectedOption = (option) => {
    const { initCountryList } = this.state;
    const scrollCountryList = initCountryList.map(item => ({ ...item, isChecked: item.value === option.value }));

    this.setState({ initCountryList: scrollCountryList, chosenCountryList: scrollCountryList });
  }

  getDefaultCountry(type, chosenCountryList = []) {
    return chosenCountryList.filter(item => item.isChecked)[0];
  }

  renderIcon() {
    if (this.isSpecialOption()) {
      return false;
    }

    return true;
  }

  renderIconElement() {
    const { type } = this.props;
    const { chosenCountryList = [], showPhonePanel } = this.state;
    const foreign = chosenCountryList.length > 1;
    const defaultCountry = this.getDefaultCountry(type, chosenCountryList) || {};

    return (
      foreign && chosenCountryList.length
        ?
        <div
          className={classnames('international-phone-box',
          { 'is-open': showPhonePanel, 'international-phone-box-icon': this.renderIcon() })}
        >
          <span onTouchTap={this.handleChange} className="international-areaCode">
            {defaultCountry.areaCode}
          </span>
        </div>
        : false
    );
  }

  render() {
    const { type } = this.props;
    const { showPhonePanel, initCountryList, chosenCountryList = [] } = this.state;
    const foreign = chosenCountryList.length > 1;
    const defaultCountry = this.getDefaultCountry(type, chosenCountryList);

    return (
      <div className={classnames({ 'international-phone': foreign, 'international-phone-foreign': !foreign })}>
        {this.renderIconElement()}

        <PhoneVerificationCode
          {...this.props}
          className="phone-verification-code--login"
          phoneNum={this.props.phoneNum || ''}
          ref="verificationCode"
          currentCountry={defaultCountry}
        />

        <ReactCSSTransitionGroup
          transitionName="slideup"
          transitionEnterTimeout={600}
          transitionLeaveTimeout={600}
        >
         {
            showPhonePanel ?
              <FloatScrollSelector
                dataList={initCountryList}
                setSelectedOption={this.setSelectedOption}
                optionComponent={PayMethodOption}
                defaultCheckedIndex={chosenCountryList.filter(item => item.isChecked)[0].id}
                selectorTitle={formatMessage(muiText.muiselectCountry)}
                toggleSelectorCheckedStatus={this.toggleSelectorCheckedStatus}
                closeSelector={this.closeModal}
              /> : false
        }
        </ReactCSSTransitionGroup>
      </div>
    );
  }
}

module.exports = InternationalPhoneVerificationCode;



// WEBPACK FOOTER //
// ./src/component/mui/form/international-phone-verification-code.jsx